import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import config from './YodaTooltip.config';
import * as styles from './YodaTooltip.css';
import Link from '../Link/Link';

const cx = classNames.bind(styles);
/**
 * tooltip placement
 *
 * TOPLEFT -> render tooltip on top of the required element positioned at left
 * BOTTOMRIGHT -> render tooltip at the bottom of the required element positioned at right
 * TOPRIGHT -> render tooltip on top of the required element positioned at right
 * BOTTOMLEFT -> render tooltip at the bottom of the required element positioned at left
 *
 * */
class YodaTooltip extends PureComponent {
    static propTypes = {
        /*
          Tooltip element on which we wants to get tooltip
        */
        children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]),
        /**
         * Set style that would be appended to tooltip body and element
         * @type {String}
         */
        tooltipBodyClassName: PropTypes.string,
        tooltipTextClass: PropTypes.string,
        /* callback function to display tooltip data that we wants to display inside tooltip */
        renderTooltipContents: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
        /* set style that would be appended to tooltip */
        tooltipContentClass: PropTypes.string,
        /* Tolltip direction */
        direction: PropTypes.oneOf([
            config.direction.BOTTOMRIGHT,
            config.direction.BOTTOMLEFT,
            config.direction.TOPRIGHT,
            config.direction.TOPLEFT,
            config.direction.RIGHT,
            config.direction.RIGHTALIGN,
            config.direction.LEFTALIGN,
        ]),
        tooltipPlacement: PropTypes.oneOf([
            config.tooltipPlacement.RIGHT,
            config.tooltipPlacement.LEFT,
            config.tooltipPlacement.MIDDLE,
        ]),
        triggerEventName: PropTypes.oneOf([
            config.triggerEventName.CLICK,
            config.triggerEventName.MOUSEOVER,
        ]),
        callBackFun: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
        onClickHandler: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
        // stayInView: PropTypes.bool,
        stayOnContentHover: PropTypes.bool,
        theme: PropTypes.string,
        /* By default onclick of tooltip conent Tooltip will get hidden - Send false to disable this feature */
        disableHideOnContentClick: PropTypes.bool,
        tabbable: PropTypes.bool,
        btnActiveClass: PropTypes.string,
        activityMapId: PropTypes.string,
        parentActivityMapId: PropTypes.string,
        tooltipType: PropTypes.string,
        linkName: PropTypes.string,
        controlledIsOpen: PropTypes.bool,
        clickTriggerTooltipOnClick: PropTypes.func,
        isListClicked: PropTypes.bool,
        isAccountHover: PropTypes.bool,
        shouldToggleOnMouseOver: PropTypes.bool,
    };

    static defaultProps = {
        placement: 'topright',
        children: 'tooltip',
        tooltipBodyClassName: '',
        tooltipTextClass: '',
        renderTooltipContents: '',
        tooltipContentClass: 'tooltip',
        direction: 'Bottomright',
        tooltipPlacement: 'Right',
        triggerEventName: config.triggerEventName.CLICK,
        callBackFun: () => {},
        onClickHandler: null,
        // stayInView: false,
        stayOnContentHover: false,
        theme: '',
        disableHideOnContentClick: false,
        tabbable: false,
        btnActiveClass: '',
        activityMapId: null,
        parentActivityMapId: null,
        tooltipType: 'button',
        linkName: null,
        controlledIsOpen: false,
        clickTriggerTooltipOnClick: null,
        isListClicked: null,
        isAccountHover: false,
        shouldToggleOnMouseOver: false,
    };

    constructor() {
        super();
        this.state = {
            tooltipPosition: '',
            isOpen: false,
        };
        this.getPosition = this.getPosition.bind(this);
        this.onClickTooltip = this.onClickTooltip.bind(this);
        this.onClickHandle = this.onClickHandle.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.containerClicked = false;
    }

    componentWillReceiveProps(nextProps) {
        // manually toggle tooltip
        if (this.props.controlledIsOpen !== nextProps.controlledIsOpen) {
            this.toggleTooltip(nextProps.controlledIsOpen);
        }
        if (
            nextProps.isListClicked &&
            this.props.isListClicked !== nextProps.isListClicked &&
            this.state.isOpen
        ) {
            this.setState({ isOpen: false });
        }
    }

    componentWillUnmount() {
        this.removeOutsideClickListener();
    }

    onClickTooltip(event) {
        if (this.props.clickTriggerTooltipOnClick) {
            // custom function to be called when clicking on click-triggered tooltip
            this.props.clickTriggerTooltipOnClick(event);
        }
        event.nativeEvent.preventDefault();
        if (this.props.triggerEventName !== event.type) return;
        // event.nativeEvent.stopImmediatePropagation();
        const position = this.getPosition();
        this.setState({
            tooltipPosition: position,
        });
        this.toggleTooltip(!this.state.isOpen);

        /* if (!this.props.stayInView) {
            this.toggleTooltip(this.state.isOpen);
        } else {
            this.toggleTooltip(!this.state.isOpen);
        } */
    }

    onClickHandle(e) {
        if (this.props.onClickHandler) {
            this.props.onClickHandler(e);
        }
    }

    getPosition() {
        let placement;
        if (this.tooltip) {
            const position = this.tooltip.getBoundingClientRect();
            const popupTop = position.top;
            const popupLeft = position.left;
            const popupWidth = position.width;
            const popupHeight = position.height;
            // const popupParentWidth = position.width;
            const windowHeight = window.innerHeight;
            const windowWidth = window.innerWidth;
            const topBoundary = popupTop - popupHeight;
            const leftBound = popupLeft - popupWidth;
            const bottomBoundary = popupTop + popupHeight;
            const leftBoundary = popupLeft > 0;
            const rightBoundary = popupLeft + popupWidth < windowWidth;
            if (bottomBoundary < windowHeight) {
                // leftBoundary>0
                if (leftBoundary && rightBoundary) {
                    placement = 'bottom';
                }
            } else if (topBoundary > 0) {
                /* istanbul ignore next */
                if (leftBoundary && rightBoundary) {
                    placement = 'top';
                }
            } else if (leftBound > 0) {
                placement = 'left';
            } else {
                placement = 'right';
            }
        }
        return placement;
    }

    setContainerClicked = () => {
        this.containerClicked = true;
    };

    addOutsideClickListener = () => {
        if (!__SERVER__) {
            document.addEventListener('click', this.toggleTooltip, false);
        }
    };

    removeOutsideClickListener = () => {
        if (!__SERVER__) {
            document.removeEventListener('click', this.toggleTooltip, false);
        }
    };

    handleMouseOver() {
        const { isOpen } = this.state;
        !isOpen && this.setState({ isOpen: !isOpen });
    }

    handleMouseLeave() {
        const { isOpen } = this.state;
        isOpen && this.setState({ isOpen: !isOpen });
    }

    toggleTooltip(value) {
        let toggle = true;
        const { disableHideOnContentClick } = this.props;
        // If disableHideOnContentClick flag is true and user clicks on tooltip content then tooltip will not be hidden.
        /* istanbul ignore next */
        if (disableHideOnContentClick && this.containerClicked) {
            this.containerClicked = false;
            toggle = false;
        }
        /* istanbul ignore next */
        if (toggle) {
            let placeValue = false;
            if (typeof value === 'boolean') {
                placeValue = value;
            }

            if (this.props.triggerEventName === config.triggerEventName.CLICK) {
                placeValue ? this.addOutsideClickListener() : this.removeOutsideClickListener();
            }
            this.setState(
                {
                    isOpen: placeValue,
                },
                () => {
                    this.props.callBackFun(this.state.isOpen);
                }
            );
        }
    }

    render() {
        let btnActiveClass;
        if (this.state.isOpen) {
            btnActiveClass = this.props.btnActiveClass;
        }
        const {
            children,
            tooltipBodyClassName,
            theme,
            tooltipTextClass,
            renderTooltipContents,
            tooltipPlacement,
            direction,
            tooltipContentClass,
            triggerEventName,
            tabbable,
            activityMapId,
            parentActivityMapId,
            tooltipType,
            linkName,
            stayOnContentHover,
            isAccountHover,
            shouldToggleOnMouseOver = false,
        } = this.props;
        const tooltipClassNames = cx('TooltipWrapper', tooltipBodyClassName, {
            accountHover: isAccountHover,
        });
        const tooltipClassname = cx(tooltipTextClass, 'tooltip');
        const tooltipContentsClassName = cx(
            'tooltip-text',
            theme,
            tooltipContentClass,
            direction,
            tooltipPlacement
        );
        const tabbableProps = !tabbable ? { tabIndex: -1 } : {};
        const additionalProps = activityMapId
            ? {
                  onClick: this.setContainerClicked,
                  id: activityMapId,
              }
            : {
                  onClick: this.setContainerClicked,
              };
        const contentHandlerProps =
            triggerEventName === config.triggerEventName.MOUSEOVER && stayOnContentHover
                ? {
                      onMouseOver: this.handleMouseOver,
                      onMouseLeave: this.handleMouseLeave,
                      onClick: this.handleMouseLeave,
                  }
                : '';
        const handlerProps =
            triggerEventName === config.triggerEventName.MOUSEOVER
                ? {
                      onMouseOver: shouldToggleOnMouseOver
                          ? this.handleMouseOver
                          : this.onClickTooltip,
                      onMouseLeave: shouldToggleOnMouseOver
                          ? this.handleMouseLeave
                          : this.toggleTooltip,
                      onClick: this.onClickHandle,
                  }
                : {
                      onClick: this.onClickTooltip,
                  };
        const parentActivityProps = parentActivityMapId ? { id: parentActivityMapId } : {};
        const linkProps =
            tooltipType === config.tooltipType.LINK
                ? {
                      href: linkName,
                  }
                : {};
        return (
            <div
                className={tooltipClassNames}
                ref={(node) => {
                    this.tooltip = node;
                }}
                onMouseDown={this.getPosition}
                {...parentActivityProps}
            >
                <Link
                    type={tooltipType}
                    className={cx(tooltipClassname, btnActiveClass)}
                    {...handlerProps}
                    {...tabbableProps}
                    {...linkProps}
                >
                    {children}
                </Link>
                <span>
                    <div
                        {...additionalProps}
                        className={tooltipContentsClassName}
                        {...contentHandlerProps}
                        style={this.state.isOpen ? { display: 'block' } : { display: 'none' }}
                    >
                        {renderTooltipContents}
                    </div>
                </span>
            </div>
        );
    }
}
export default YodaTooltip;
